import React         from 'react';
import ThemeSettings from '../../../theme';
import { isServer }  from '../../../utils';

type ResponsiveProps = {
    minWidth?: number;
    maxWidth?: number;
    orientation?: string;
};

class Responsive extends React.Component<ResponsiveProps> {
    state = {
        render: Date.now(),
    };

    checkMediaQuery(): boolean {
        if (isServer) {
            return !this.props.maxWidth;
        }

        return !!window.matchMedia(this.getQuery()).matches;
    }

    getQuery(): string {
        const {minWidth, maxWidth, orientation} = this.props;

        if (minWidth) {
            return `(min-width: ${minWidth}px)`;
        }

        if (maxWidth) {
            return `(max-width: ${maxWidth}px)`;
        }

        if (orientation) {
            return `(orientation: ${orientation})`;
        }
    }

    onResize = () => {
        this.setState({
            date: Date.now(),
        });
    }

    componentDidMount() {
        if (!isServer) {
            window.addEventListener('resize', this.onResize);
        }

        this.onResize();
    }

    componentWillUnmount() {
        if (!isServer) {
            window.removeEventListener('resize', this.onResize);
        }
    }

    render() {
        const chk = this.checkMediaQuery();

        if (chk) {
            return this.props.children;
        }

        return null;
    }
}

export const DesktopQuery = (props: any) => {
    return <Responsive {...props} minWidth={ThemeSettings.breakPoints.desktop} />;
};

export const MobileQuery = (props: any) => {
    return <Responsive {...props} maxWidth={ThemeSettings.breakPoints.mobile} />;
};

export const LandscapeQuery = (props: any) => {
    return <Responsive {...props} orientation='landscape' />;
};

export const PortraitQuery = (props: any) => {
    return <Responsive {...props} orientation='portrait' />;
};

